import { Paper } from '@material-ui/core';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes } from 'routes';

export const footerHeight = '20px';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: footerHeight,
    width: '100%',
    position: 'fixed',
    bottom: '0px',
    zIndex: theme.zIndex.drawer,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid',
  },
  changelog: {
    textDecoration: 'none',
    color: 'inherit',
  },
}));

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const location = useLocation();

  return (
    <Paper className={classes.wrapper} square>
      <Link to={{ pathname: Routes.InfoPage, state: { referer: location.pathname } }} className={classes.changelog}>
        {t('footer.copyright', {
          year: new Date().getFullYear(),
          version: process.env.,
        })}
      </Link>
    </Paper>
  );
};
export default Footer;
